import { Controller } from "stimulus"

// This controller unsures any links in RichText area's open in a new window.
export default class extends Controller {
  connect() {
    this.element.querySelectorAll('a').forEach(function(link) {
      if (link.host !== window.location.host) {
        link.target = "_blank"
      }
    })
  }
}
